const orderTypes = {
    FETCH_ORDERS_BY_CUSTOMER_START: 'FETCH_ORDERS_BY_CUSTOMER_START',
    SET_ORDERS_BY_CUSTOMER: 'SET_ORDERS_BY_CUSTOMER',
};

export default orderTypes;
